<template>
  <v-card
    :href="url || ''"
    style="text-decoration: none; color: inherit;"
  >
    <v-list-item class="ml-3">
      <v-list-item-avatar size="50">
        <v-img :src="imageUrl" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="text-wrap text-sm-h4 text-md-h3 text-lg-h2" v-text="title" />
        <v-list-item-subtitle v-if="showSubtitle">
          <slot name="subtitle" class="text-wrap" />
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
export default {
  props: {
    title: String,
    showSubtitle: Boolean,
    imageUrl: String,
    url: String,
  },
};
</script>
